import { useEffect, useRef } from 'react';

/* Esc fecha o modal -- e só o de CIMA quando há um aberto sobre outro
   (ex.: editar um registro dentro da ficha do cliente): uma pilha guarda
   os modais abertos na ordem em que abriram, e o Esc chama só o último.

   Regra do sistema: modal NÃO fecha clicando fora (perdia o que estava
   sendo feito com um clique sem querer) -- fecha só no Esc ou no botão
   de fechar. Este hook é a parte do Esc. `ativo` serve pra modal que
   vive dentro de outro componente e só existe quando um estado está ligado. */
const pilha = [];

function aoTeclar(e) {
  if (e.key !== 'Escape' || !pilha.length) return;
  pilha[pilha.length - 1].current?.();
}

export default function useEsc(onFechar, ativo = true) {
  const ref = useRef(onFechar);
  ref.current = onFechar;
  useEffect(() => {
    if (!ativo) return undefined;
    if (!pilha.length) window.addEventListener('keydown', aoTeclar);
    pilha.push(ref);
    return () => {
      const i = pilha.lastIndexOf(ref);
      if (i >= 0) pilha.splice(i, 1);
      if (!pilha.length) window.removeEventListener('keydown', aoTeclar);
    };
  }, [ativo]);
}
